import { packProposalPages } from "./packProposalPages.js";

/**
 * Open the proposal at full A4 size and hand it to the browser print dialog,
 * which saves a PDF. The iframe has to be tall enough for every sheet;
 * a one-page or zero-size frame prints a clipped page.
 * @param {string} html
 * @param {string} filename
 */
export function downloadProposalPdf(html, filename) {
    const title = String(filename || "Proposal").replace(/\.pdf$/i, "");
    const iframe = document.createElement("iframe");
    iframe.setAttribute("title", title);
    iframe.style.cssText = "position:fixed;left:-10000px;top:0;width:210mm;height:297mm;border:0;";
    iframe.srcdoc = html.replace("<head>", `<head><title>${title.replace(/</g, "")}</title>`);
    document.body.appendChild(iframe);

    iframe.onload = () => {
        const win = iframe.contentWindow;
        const doc = iframe.contentDocument;
        if (!win || !doc) {
            iframe.remove();
            return;
        }
        packProposalPages(doc.querySelector(".proposal-preview-root"));
        const pages = doc.querySelectorAll(".tpl-cover, .tpl-toc, .tpl-print-page").length;
        iframe.style.height = `${Math.max(pages, 1) * 297}mm`;
        const pending = [...doc.images].filter((img) => !img.complete);
        const ready = pending.length
            ? Promise.all(pending.map((img) => new Promise((resolve) => {
                img.addEventListener("load", resolve, { once: true });
                img.addEventListener("error", resolve, { once: true });
            })))
            : Promise.resolve();
        ready.then(() => {
            const cleanup = () => iframe.remove();
            win.addEventListener("afterprint", cleanup, { once: true });
            win.focus();
            win.print();
            window.setTimeout(cleanup, 60_000);
        });
    };
}
